<p-dialog
    [(visible)]="visible"
    [modal]="true"
    [closable]="closable"
    [draggable]="false"
    [resizable]="false"
    styleClass="pipeline-dialog"
    [style]="{ width: '42rem' }"
>
    <ng-template pTemplate="header">
        <div class="pipeline-dialog__header">
            <i class="pi"
               [ngClass]="todoCompletado ? 'pi-check-circle pipeline-header__icon--ok' : 'pi-spin pi-spinner pipeline-header__icon--spin'">
            </i>
            <span>{{ todoCompletado ? 'Novedad procesada exitosamente' : 'Procesando novedad...' }}</span>
        </div>
    </ng-template>

    <div class="pipeline-wrapper">

        <p class="pipeline-header__subtitle">
            {{ todoCompletado
                ? 'Todos los sistemas han registrado los cambios.'
                : 'Una novedad de esta remisión está siendo procesada por los sistemas. Por favor espera.' }}
        </p>

        <div class="pipeline-track">
            <ng-container *ngFor="let paso of pasos; let i = index; let last = last">

                <div class="pipeline-step" [ngClass]="'pipeline-step--' + paso.estado">

                    <div class="pipeline-step__circle">
                        <ng-container [ngSwitch]="paso.estado">
                            <i *ngSwitchCase="'completado'"  class="pi pi-check"></i>
                            <i *ngSwitchCase="'en-progreso'" class="pi pi-spin pi-spinner"></i>
                            <i *ngSwitchCase="'pendiente'"   class="pi pi-clock"></i>
                        </ng-container>
                    </div>

                    <div class="pipeline-step__info">
                        <span class="pipeline-step__label">{{ paso.label }}</span>
                        <span class="pipeline-step__desc">{{ paso.descripcion }}</span>
                        <span class="pipeline-step__badge" [ngClass]="'pipeline-step__badge--' + paso.estado">
                            <ng-container [ngSwitch]="paso.estado">
                                <ng-container *ngSwitchCase="'completado'">Completado</ng-container>
                                <ng-container *ngSwitchCase="'en-progreso'">En progreso</ng-container>
                                <ng-container *ngSwitchCase="'pendiente'">Pendiente</ng-container>
                            </ng-container>
                        </span>
                    </div>

                </div>

                <div *ngIf="!last" class="pipeline-connector"
                     [ngClass]="pasos[i].estado === 'completado' ? 'pipeline-connector--activo' : 'pipeline-connector--inactivo'">
                </div>

            </ng-container>
        </div>

    </div>

    <ng-template pTemplate="footer">
        <p-button
            label="Aceptar"
            icon="pi pi-check"
            [rounded]="true"
            class="main-button"
            (click)="onCerrar()"
        />
    </ng-template>

</p-dialog>

